import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { getProjectsDetail } from '../../../api/Projects';
import { getReportList } from '../../../api/Report';
import PageContent from '../../../components/PageContent';
import {Button, message, notification, Spin} from 'antd';
import ReportTable from '../../../components/ReportTable';
import { ReportsIcon } from '../../../icons';
import MarkdownIt from "markdown-it";
import { SubmitReportButton } from '../../../components/CustomForm';
import {
    currentToken,
    currentUser,
    isCompany, setUser,
} from '../../../features/user/userSlice';
import {useDispatch, useSelector} from 'react-redux';
import {getPersonalInfo} from "../../../api/User";
import {getContestDetail, getContests} from "../../../api/Contests";
import {Tabs} from "../../../components/Tabs";

const mdParser = new MarkdownIt();

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
`;

const DetailContainer = styled.div``;

const DetailContent = styled.div`
  color: #cfcfcf;
  padding-bottom: 0;
  padding-top: 39px;
  margin-bottom: 20px;
`;

const ProjectsName = styled.h3`
  font-size: 28px;
  line-height: 1.5;
  font-weight: 700;
  color: #fff;
`;

const ProjectsDsc = styled.p`
  font-size: 14px;
  line-height: 24px;
  color: #8a949e;
`;

const Detail = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [search] = useSearchParams();
  const _isCompany = useSelector(isCompany);
  const user = useSelector(currentUser);
    const token = useSelector(currentToken);
    const dispatch = useDispatch();

  // 变量定义
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [pageOptions, setPageOptions] = useState({
    total: 0,
    currentPage: 1,
    perSize: 10,
  });

  // 初始化
  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  useEffect(() => {
    if (data && data.name) {
      fetchTableData(data.name);
    }
  }, [data.name]);

  const navigate =  useNavigate();

    const fetchDetail = (id) => {
        const type = search.get('type')
        if (+type === 2) return getContestDetail(id)
        return getProjectsDetail(id)
    }

  const fetchData = async () => {
    try {
        console.log(id)
      const {data} = await fetchDetail(encodeURIComponent(id));
      if(data === undefined) {
          message.error('Projects does not exist');
          function timeout(delay) {
            return new Promise( res => setTimeout(res, delay) );
          }
          await timeout(1000);
          navigate(-1);
          return;
      }
      setData(data);
    } catch (error) {
      // console.log(error);
    }
    setLoading(false);
  };

  // 数据获取
  const fetchTableData = async (company_name, page, pageSize) => {
    try {
      const { data } = await getReportList({ company_name, page, pageSize, ...pageOptions });
      setTableData(data.list);
      setPageOptions({
        ...pageOptions,
        total: data.total,
        currentPage: data.current_page,
        perSize: data.per_page,
      });
      setTableLoading(false);
    } catch (error) {}
  };

  // 分页处理
  const handlePageChange = (page, pageSize) => {
    setPageOptions({
      ...pageOptions,
      currentPage: page,
      pageSize,
    });
    setTableLoading(true);
    fetchTableData(data.name, page, pageSize);
  };

  const items = [{
    label: t('user_center.Policy'), key: '1', children: (
        <div dangerouslySetInnerHTML={{__html: mdParser.render(data.policy ?? '')}} className='custom-html-style detail-markdown' />
    )
  }, {
    label: t('report')+'('+pageOptions.total+')', key: '2', children: (
        <ReportTable
            data={tableData}
            loading={tableLoading}
            pagination={{
              showSizeChanger: false,
              showQuickJumper: false,
              total: pageOptions.total,
              current: pageOptions.currentPage,
              pageSize: pageOptions.perSize,
              onChange: (page, pageSize) => {
                handlePageChange(page, pageSize);
              },
            }}
        />
    )
  }]

  const toAddReport = async (item) => {
      if (!token) {
          navigate('/login');
          return message.warning('Please login first');
      } else {
          if (!user.user.wallet_address || user.user.wallet_address === '') {
              const {code, data} = await getPersonalInfo();
              if (code === '10000') {
                  if (data.hacker.wallet_address) {
                      const user = JSON.parse(localStorage.getItem('user'));
                      user.user.wallet_address = data.hacker.wallet_address;
                      dispatch(setUser(user));
                      navigate('/addreport');
                  } else {
                      return notification.warning({
                          key: 'warning',
                          description: (
                              <span
                                  style={{
                                      fontSize: '16px',
                                  }}
                              >
                  Please set your wallet address before submitting your report.
                </span>
                          ),
                          btn: (
                              <Button
                                  size="small"
                                  style={{
                                      height: '32px',
                                      backgroundColor: '#18EAC4',
                                      borderColor: '#18EAC4',
                                      color: '#000',
                                      borderRadius: '6px',
                                  }}
                                  onClick={() => {
                                      notification.close('warning');
                                      navigate('/user?page=my_info', {state: {wallet_address: true}});
                                  }}
                              >
                                  Setting
                              </Button>
                          ),
                      });
                  }
              }
          } else {
              navigate(`/addreport?project=${item.name}&project_id=${item.id}`);
          }
      }
  };

  return (
    <Container>
      <Spin spinning={loading}>
        <DetailContainer>
          <PageContent
            title={
              <DetailContent className="custom-html-style">
                <ProjectsName>
                  {data.name}
                  {!_isCompany && (
                    <SubmitReportButton style={{float:'right'}} onClick={() => toAddReport(data)}>Submit a Report</SubmitReportButton>
                  )}
                </ProjectsName>
                <ProjectsDsc>{data.description}</ProjectsDsc>
                

              </DetailContent>
            }
          >
            <Tabs items={items} />
          </PageContent>
        </DetailContainer>
      </Spin>
    </Container>
  );
};
export default Detail;
// Compare this snippet from bbs-frontend\src\views\Projects\index.js:
